import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import Sidebar_component from './Sidebar_component'
import $ from 'jquery'
export default function My_worklist() {
    const [listMyTaskArray, setListMyTaskArray] = useState([]);
    const [showHistoryPopup, setShowHistoryPopup] = useState(false);
    const [historyData, setHistoryData] = useState([]);
    const [taskTitle, setTaskTitle] = useState('');
    const [membretype, setMembertype] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const navigate = useNavigate();
    useEffect(() => {
        let memtype = localStorage.getItem('membership_type');
        if (memtype === 'free') {
            setMembertype(true);
        }
        const userid = localStorage.getItem('member_id');
        var obj = {
            user_id: userid,
        }
        $.ajax({
            type: 'POST',
            url: 'getMyTgaskHistory.php',
            data: obj,
            cache: false,
            success: function (result) {
                var res = result;
                console.log(res);
                if (res !== 'fail' && res !== '') {
                    var arr = JSON.parse(res);
                    console.log(arr);
                    setListMyTaskArray(arr)
                } else {
                    showAlert("Hmm… it looks like no tasks have been assigned to you yet.");
                    $('#norecord').css('display', 'block');
                }
            },
        });
    }, []);

    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }
    function openHistory(item) {
        setHistoryData(item.timetracking);
        setTaskTitle(item.tsk_name || 'Task History');
        setShowHistoryPopup(true);
        // $('#detailsbox').css('display','block')
    }
    function closeHistory() {
        setShowHistoryPopup(false);
        setHistoryData([]);
    }

    function calculateTotalTime(entries) {
        let totalSeconds = 0;
        entries.forEach(e => {
            const [h, m, s] = e.time_worked.split(':').map(Number);
            totalSeconds += h * 3600 + m * 60 + s;
        });
        const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
        const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
        const seconds = String(totalSeconds % 60).padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
    }

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <div className='vl_alltab'>
                    <h2 className='bigfonttabs'>Work History (last 30 days)</h2>
                    <Link className='pull_right add_new_pro' to="/my_task">My task list</Link>
                </div>
                <section className='vl_dsh_bodypart_section pos_rel'>
                    <div className='vl_listing_area'>

                        <div className='vl_listing_row nodisplay' id="norecord">
                            <h1 className='notice_text'> No Record Found</h1>
                        </div>
                        {listMyTaskArray.map((item, index) => {


                            return (
                                <div className='resource_card_one_third' key={index}>
                                    <div className='resource_inner'>
                                        <div className='fullwidth pull_left pt-21'>
                                            <h4 className='prj_name'>{item.proname}</h4>
                                        </div>
                                        <div className='divider'>&nbsp;</div>
                                        <div className='vl_dsh_one_half'>
                                            <p>Task Name:{item.tsk_name}</p>
                                        </div>
                                        <div className='vl_dsh_one_half'>
                                            <p>Status: {item.tsk_status}</p>
                                        </div>

                                        <div className='vl_dsh_one_full'>
                                            <p>{item.tsx_desc}</p>
                                        </div>

                                        <div className='list_buttonholder'>
                                            {item.timetracking.length > 0 ? (
                                                <button onClick={() => openHistory(item)}>
                                                    Open History
                                                </button>
                                            ) : (
                                                <span className="no-history-text">No History</span>
                                            )}
                                        </div>


                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    {showHistoryPopup && (
                        <div className="vl_dsh_popup_details" id="detailsbox">
                            <div className="alertbox_hig large">

                                <div className="alertheader">
                                    <h3>{taskTitle} — Work History</h3>
                                </div>

                                <div className="contentarea">

                                    <table className="history-table">
                                        <thead>
                                            <tr>
                                                <th>Date of Work</th>
                                                <th>Start Time</th>
                                                <th>End Time</th>
                                                <th>History</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {historyData.map((row, idx) => (
                                                <tr key={idx}>
                                                    <td>{row.dateofWork}</td>
                                                    <td>{row.start_time}</td>
                                                    <td>{row.end_time}</td>
                                                    <td>{row.time_worked}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                    <div className="total-hours">
                                        <div>

                                            Total Working Hours from {historyData[0].dateofWork} to{' '}
                                            {historyData[historyData.length - 1].dateofWork}
                                            :  <span className="highlighttext">{calculateTotalTime(historyData)}</span>
                                        </div>
                                    </div>

                                </div>

                                <div className="alert_btns">
                                    <button onClick={closeHistory}>Close</button>
                                </div>

                            </div>
                        </div>
                    )}

                </section>
            </div>
            <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Okay</button>
                    </div>
                </div>
            </div>
            {membretype && (
                <div className='vl_dsh_popup activebillpop'>
                    <div className='alertbox'>
                        <div className='alertheader'>
                            <h3><i className='ri-alert-line'></i>Alert</h3>
                        </div>

                        <div className='contentarea'>
                            <p>Please upgrade your membership to access this page</p>
                        </div>
                        <div className='alert_btns'>
                            <button onClick={() => window.history.back()}>Back</button>
                        </div>

                    </div>
                </div>
            )}
        </div>
    )
}
